<template>
  <el-form>
    <el-col :span="12" v-if="gpsParam">
      <el-form-item :label="$t('public.gps_switch')">
        {{ gpsParam.gps_switch ? $t('public.open') : $t('public.close') }}
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
export default {
  props: {
    detailData: {}
  },
  computed: {
    gpsParam () {
      return this.detailData.gpsConfig
    }
  }
}
</script>
